module.exports = __webpack_public_path__ + "static/media/sliderNews3400px.332c08bd.jpg";